import { render, staticRenderFns } from "./advert.vue?vue&type=template&id=6139500a&scoped=true&"
import script from "./advert.vue?vue&type=script&lang=js&"
export * from "./advert.vue?vue&type=script&lang=js&"
import style0 from "./advert.vue?vue&type=style&index=0&id=6139500a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6139500a",
  null
  
)

export default component.exports